import { DeliveryAddress } from './order-details';

export interface MancoOrderRequest {
  forOrderNumber: string;
  forCustomerNumber: string;
  mancoType: MancoType;
  freshdeskTicketNumber: string;
  ishShippingMethodID: string;
  // ISO yyyy-MM-dd. Absent means today, the as-soon-as-possible manco default.
  fixedDeliveryDate?: string;
  deliveryAddress: APIDeliveryAddress;
  orderlines: MancoOrderline[];
  note?: string;
  followUpNeeded: boolean;
  customerRef?: string;
  createdByHint?: string;
  userUUID?: string;
  invoiceEmailAddress?: string;
  userDisplayName?: string;
}

export interface MancoOrderline {
  rowNumber: number; // row number of manco
  lineIDSource?: string; // original line position
  sku: string;
  nameSource?: string;
  quantitySource: number;
  orderlineRef?: string;
  properties?: Record<string, string>;
}

export interface APIDeliveryAddress extends DeliveryAddress {
  company: string;
}

export enum MancoType {
  MancoCarrier = 'mancoCarrier',
  MancoSupplier = 'mancoSupplier',
  IncorrectRedelivery = 'incorrectRedelivery',
  DamageRedelivery = 'damageRedelivery',
  Warranty = 'warranty',
  SalesCosts = 'salesCosts',
}
export const parseMancoType = (value?: string): MancoType | undefined => {
  if (Object.values(MancoType).includes(value as MancoType)) {
    return value as MancoType;
  }
  return undefined;
};

export interface MancoOrderResponse {
  orderNumber: string;
  freshdeskNoteCreated: boolean;
  request?: MancoOrderRequest;
}

export const MancoTypeOptions = [
  // comment = customerNo of mancoAccount
  { value: MancoType.MancoCarrier, label: 'Manco vervoerder' }, // 3390003
  { value: MancoType.MancoSupplier, label: 'Manco kramp' }, // 3390013
  { value: MancoType.IncorrectRedelivery, label: 'Foutieve herlevering' }, // 3390004
  { value: MancoType.DamageRedelivery, label: 'Schade herlevering' }, // 3390001
  { value: MancoType.Warranty, label: 'Garantie' }, // 3390005
  { value: MancoType.SalesCosts, label: 'Verkoopkosten' }, // 3390002
];

export const FollowUpNeededOptions = [
  { value: true, label: 'Opvolgen' },
  { value: false, label: 'Geen opvolging nodig' },
];

export const parseFollowUpNeededOption = (raw?: string | boolean): boolean | undefined => {
  switch (raw) {
    case true:
    case 'true':
      return true;
    case false:
    case 'false':
      return false;
    default:
      return undefined;
  }
};

export const getMancoTypeLabel = (value: MancoType): string => {
  const option = MancoTypeOptions.find(o => o.value === value);
  return option ? option.label : '';
};
